import * as React from 'react';
import ModalDecisionComponent from './storyModal/ModalDecisionComponent';
import ReactHtmlParser from 'react-html-parser';
import AppConfig from 'src/config/AppConfig';
import Leaderboard from './Leaderboard';
import PlayerStatComponent from './PlayerStatComponent';
import ScoreUtils from 'src/utils/ScoreUtils';
import '../sass/StoryTextComponent.css';
import AppUtils from 'src/utils/AppUtils';
import { CSSTransitionGroup } from 'react-transition-group' // ES6
import Story from 'src/objects/Story';
import Chapter from 'src/objects/Chapter';

export default class StoryTextComponent extends React.Component<any, any> {
    
    // private newChapterInfoShowing:boolean = false;
    private decisionTimer:NodeJS.Timer;
    private decisionBonus:number;

    constructor(props:any) {
        super(props);

        this.state = {
            chapters: this.props.playerChapterData,
            noStoryButton: 'Back to start',
            gameOverDecision: 'How did I do?',
            newChapterInfoShowing: false,
            showingSummary: false,
            showingScore: false,
            showingRestart: false,
            playerPosition: "99+",
        }

        this.chapterContinuePressed = this.chapterContinuePressed.bind(this);
        this.getStory = this.getStory.bind(this)
        this.showScore = this.showScore.bind(this);
        this.showSummary = this.showSummary.bind(this);
        this.restartGame = this.restartGame.bind(this);
        this.setPlayerPosition = this.setPlayerPosition.bind(this);
        this.getSpeedBonus = this.getSpeedBonus.bind(this);
        this.getNegativeScore = this.getNegativeScore.bind(this);
        this.getPositiveScore = this.getPositiveScore.bind(this);
        this.decisionSelected = this.decisionSelected.bind(this);
    }

    onUpdateItem = i => {
        this.setState(state => {
          const list = state.storys.map((item:Story, j:number) => {
            if (j === i) {
              return item.decisions.splice(0,1);
            } else {
              return item;
            }
          });
    
          return {
            list,
          };
        });
      };
    

    private startCountdown() {
        this.decisionBonus = ScoreUtils.BONUS_COUNTDOWN;
        this.decisionTimer = setInterval(() => {
            // console.log(this.decisionBonus);
            this.decisionBonus--;
            if(this.decisionBonus < 0 ){
                clearInterval(this.decisionTimer);
            };
        }, 500);
    };

    componentWillUnmount() {
        clearInterval(this.decisionTimer);
    }

    componentDidUpdate() {
        if (this.props.characterReady) {
            // console.log("story text component updated")
            clearInterval(this.decisionTimer);
            this.startCountdown()
        }
    }

    private storyExists():boolean {
        if (this.getStory() == null) {
            // console.log("Story doesn't exist! ", parseInt(this.props.activeKey)-1, this.props.playerChapterData.storys, this.props.currentChapter);
            return false;
        }
        return true;
    }

    private getStory():Story {
        let story:Story = this.state.chapters[this.props.currentChapter].storys[parseInt(this.props.activeKey)-1];
        return story;
    }

    private decisionSelected(jumpPage:string, outcome:string, impact:string, move:string, jumpChapterId:number, speedBonus:number, link:string, decisionId:number) {
        let story:Story = this.getStory()
        if (story.onceOnly) {
            if (story.decisions.length > 1) {
                let chaptersNew:Array<Chapter> = [...this.state.chapters];
                chaptersNew[this.props.currentChapter].storys[parseInt(this.props.activeKey)-1].decisions.splice(decisionId,1);
                this.setState({chapters: chaptersNew})
            }
        }
        this.props.jumpToStory(jumpPage, outcome, impact, move, jumpChapterId, speedBonus, link, decisionId);
    }

    private getStoryText():string {
        if (this.props.isNewChapter && this.state.newChapterInfoShowing == false && this.props.currentChapter > 1) {
            return ReactHtmlParser(AppConfig.COPY_MILESTONE_TEXT);
        }
        let storyText:string = this.getStory().text;
        storyText = storyText.replace(/{name}/g, "<b style='color:#12C4C4'>" + this.props.userData.firstName + "</b>")
        return ReactHtmlParser(storyText);
    }

    private getDecisionText(i:number):string {
        if (this.props.isNewChapter && this.state.newChapterInfoShowing == false && this.props.currentChapter > 1) {
            return "Continue"
        }
        return this.getStory().decisions[i].decision;
    }

    private chapterContinuePressed():void {
        this.setState({newChapterInfoShowing: false});
        this.props.newChapterBegun();
    }

    private restartGame():void {
        this.setState({
            newChapterInfoShowing: false,
            showingSummary: false,
            showingScore: false,
            showingRestart: false,
        })
        this.props.restartGame();
    }

    private setPlayerPosition(position:number):void {
        this.setState({playerPosition: position.toString()});
    }

    private showSummary():void {
        this.setState({showingSummary:true, showingScore:false});
    }

    private showScore():void {
        this.setState({showingScore:true, showingSummary:false});
    }

    private getPositiveScore():string {
        let score:number = Math.floor((this.props.userData.positive * 100) / this.props.userData.progress);
        let scoreString:string = score.toString() + "%";
        return scoreString;
    }

    private getNegativeScore():string {
        let score:number = Math.floor((this.props.userData.negative * 100) / this.props.userData.progress);
        let scoreString:string = score.toString() + "%";
        return scoreString;
    }

    private getSummary():string {
        let scoreSummary:string = "You made <span class='summaryStat'>" + this.props.userData.progress + "</span> decisions, <span class='summaryStat'>" + this.getPositiveScore() + "</span> were good and <span class='summaryStat'>" + this.getNegativeScore() + "</span> were bad. You scored <span class='summaryStat'>" + this.props.userData.score + "</span> points, which is better than <span class='summaryStat'>67%</span> of players.";
        return scoreSummary;
    }

    private getScoreSummary():string {
        let scoreSummary:string = "Your <b>best</b> score is <span class='summaryStat'>" + this.props.userData.highscore + "</span>, ranking you in the top <span class='summaryStat'>76%</span> and number <span class='summaryStat'>" + this.state.playerPosition + "</span> overall";
        return scoreSummary;
    }

    private getSpeedBonus():number {
        // console.log("getting speed bonus:", this.decisionBonus)
        let speedBonus = this.decisionBonus;
        clearInterval(this.decisionTimer);
        return speedBonus;
    }

    private newChapterBegun() {
        this.setState({newChapterInfoShowing: false});
        this.props.jumpToStory();
    }

    private editItemSelected() {
    }

    render() {
        return (
            <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
            <div id='storyTextContainer' suppressContentEditableWarning={true} style={{left: this.props.userData.admin && !AppUtils.isMobile? "33px" : "0px"}}>
            {
                this.storyExists() && !this.props.isDead && !this.props.gameEnded && !this.props.isStoryViewPanelVisible && this.props.characterReady && this.props.userDataProgress != null && this.props.loaded != false ? 
                <div id= 'storyTextInner'>
                    {/* <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}> */}
                    <div suppressContentEditableWarning={true} id='storyText'>{this.getStoryText()}</div>
                    {
                            this.props.isNewChapter && this.state.newChapterInfoShowing == false && this.props.currentChapter > 1 ?
                            <>
                            <PlayerStatComponent settings={this.props.settings} userData={this.props.userData}/>
                            <ul>
                                <ModalDecisionComponent 
                                    id="continue"
                                    key="continue"
                                    shouldJump={false}
                                    jumpPage="1"
                                    jumpChapter={0}
                                    currentChapter={0}
                                    outcome=""
                                    impact=""
                                    move="Stay"
                                    getSpeedBonus={this.getSpeedBonus}
                                    linkUrl=""
                                    text={"Continue"}
                                    decisionSelected={this.props.isNewChapter && this.state.newChapterInfoShowing == false && this.props.currentChapter > 1 ? this.chapterContinuePressed : this.decisionSelected}>
                                </ModalDecisionComponent>

                            </ul>
                            </>
                            : 
                            // <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}>
                            <ul>
                            {this.getStory().decisions.map((c:any, i:number) => 
                            <ModalDecisionComponent 
                                id={i.toString()}
                                key={i.toString()}
                                shouldJump={c.shouldJump}
                                jumpPage={c.jumpPage}
                                jumpChapter={c.jumpChapter}
                                currentChapter={this.props.currentChapter}
                                outcome={c.outcome}
                                impact={c.impact}
                                move={c.move}
                                getSpeedBonus={this.getSpeedBonus}
                                linkUrl={c.linkUrl}
                                text={this.getDecisionText(i)}
                                decisionSelected={this.props.isNewChapter && this.state.newChapterInfoShowing == false && this.props.currentChapter > 1 ? this.chapterContinuePressed : this.decisionSelected}>
                            </ModalDecisionComponent>)}
                        </ul>
                    }
                    {/* </CSSTransitionGroup> */}
                </div> : null
            }
            {
                !this.props.isDead && !this.state.showingScore && !this.state.showingSummary && !this.storyExists() && !this.props.isStoryViewPanelVisible && this.props.characterReady && this.props.userDataProgress != null && this.props.loaded != false ? 
                <div id='storyTextInner'>
                    {/* <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}> */}
                    <div suppressContentEditableWarning={true} id='storyText'>{ReactHtmlParser(AppConfig.COPY_NO_STORY_TEXT)}</div>
                    <ul>
                        <ModalDecisionComponent 
                            id="error1"
                            key="error1"
                            shouldJump={false}
                            jumpPage="1"
                            jumpChapter={0}
                            currentChapter={0}
                            outcome=""
                            impact=""
                            move="Stay"
                            getSpeedBonus={this.getSpeedBonus}
                            text={this.state.noStoryButton}
                            decisionSelected={this.decisionSelected}>
                        </ModalDecisionComponent>
                    </ul>
                    {/* </CSSTransitionGroup> */}
                </div> : null
            }
            {
                !this.props.isDead && !this.state.showingScore && !this.state.showingSummary && this.props.gameEnded && this.props.characterReady ? 
                <div id='storyTextInner'>
                    {/* <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}> */}
                  <div suppressContentEditableWarning={true} id='storyText'>{ReactHtmlParser(this.props.text.game.gameOver)}</div>
                  <ul>
                      <ModalDecisionComponent 
                        id="error1"
                        key="error1"
                        shouldJump={false}
                        jumpPage="1"
                        jumpChapter={0}
                        currentChapter={0}
                        outcome=""
                        impact=""
                        move="Stay"
                        getSpeedBonus={this.getSpeedBonus}
                        text={this.state.gameOverDecision}
                        decisionSelected={this.showSummary}>
                      </ModalDecisionComponent>
                  </ul>
                  {/* </CSSTransitionGroup> */}
                </div> : null
            }
            {
                this.props.isDead && !this.state.showingScore && !this.state.showingSummary && this.props.characterReady ? 
                <div id='storyTextInner'>
                    {/* <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}> */}
                  <div id='storyText'>{ReactHtmlParser(this.props.text.game.playerDied)}</div>
                  <ul>
                      <ModalDecisionComponent 
                        id="error1"
                        key="error1"
                        shouldJump={false}
                        jumpPage="1"
                        jumpChapter={0}
                        currentChapter={0}
                        outcome=""
                        impact=""
                        move="Stay"
                        getSpeedBonus={this.getSpeedBonus}
                        text={this.state.gameOverDecision}
                        decisionSelected={this.showSummary}>
                      </ModalDecisionComponent>
                  </ul>
                  {/* </CSSTransitionGroup> */}
                </div> : null
            }
            {
                this.state.showingSummary && this.props.characterReady ? 
                <div id='storyTextInner'>
                 {/* <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}> */}
                  <div id='storyText'>{ReactHtmlParser(this.getSummary())}</div>
                  <Leaderboard settings={this.props.settings} setPlayerPosition={this.setPlayerPosition} showPlayerScore={false} showPlayerStat={true} showLeaderboard={false} userData={this.props.userData} leaderboardDatabaseRef={this.props.leaderboardDatabaseRef}/>
                  <ul>
                      <ModalDecisionComponent 
                        id="error1"
                        key="error1"
                        shouldJump={false}
                        jumpPage="1"
                        jumpChapter={0}
                        currentChapter={0}
                        outcome=""
                        impact=""
                        move="Stay"
                        getSpeedBonus={this.getSpeedBonus}
                        text={"View the leaderboard"}
                        decisionSelected={this.showScore}>
                      </ModalDecisionComponent>
                  </ul>
                  {/* </CSSTransitionGroup> */}
                </div> : null
            }
            {
                this.state.showingScore && this.props.characterReady ? 
                <div id='storyTextInner'>
                    {/* <CSSTransitionGroup transitionName="example" transitionAppear={true} transitionAppearTimeout={500} transitionEnterTimeout={500} transitionLeaveTimeout={300}> */}

                  <div id='storyText'>{ReactHtmlParser(this.getScoreSummary())}</div>
                  <Leaderboard settings={this.props.settings} setPlayerPosition={this.setPlayerPosition} showPlayerScore={true} showPlayerStat={false} showLeaderboard={true} userData={this.props.userData} leaderboardDatabaseRef={this.props.leaderboardDatabaseRef}/>
                  <ul>
                      <ModalDecisionComponent 
                        id="error1"
                        key="error1"
                        shouldJump={false}
                        jumpPage="1"
                        jumpChapter={0}
                        currentChapter={0}
                        outcome=""
                        impact=""
                        move="Stay"
                        getSpeedBonus={this.getSpeedBonus}
                        text={"Play again?"}
                        decisionSelected={this.restartGame}>
                      </ModalDecisionComponent>
                  </ul>
                  {/* </CSSTransitionGroup> */}
                </div> : null
            }
            {/* {
                this.state.showingScore && this.props.characterReady ? 
                <div id='storyTextInner'>
                  <div id='storyText'>{ReactHtmlParser(this.getScoreSummary())}</div>
                  <Leaderboard showPlayerScore={true} showPlayerStat={false} showLeaderboard={true} userData={this.props.userData} leaderboardDatabaseRef={this.props.leaderboardDatabaseRef}/>
                  <ul>
                      <ModalDecisionComponent 
                        id="error1"
                        key="error1"
                        shouldJump={false}
                        jumpPage="1"
                        jumpChapter={0}
                        currentChapter={0}
                        outcome=""
                        impact=""
                        move="Stay"
                        text={"Play again"}
                        decisionSelected={this.showScore}>
                      </ModalDecisionComponent>
                      <ModalDecisionComponent 
                        id="error1"
                        key="error1"
                        shouldJump={false}
                        jumpPage="1"
                        jumpChapter={0}
                        currentChapter={0}
                        outcome=""
                        impact=""
                        move="Stay"
                        text={"Play again"}
                        decisionSelected={this.showScore}>
                      </ModalDecisionComponent>
                  </ul>
                </div> : null
            } */}
            </div>
            </CSSTransitionGroup>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/StoryTextComponent.tsx